<template>
  <div class="redesign">
    <Header :menu-at="0" headerTitle="Tests and Ideas"/>
    <vue-headful title="Tests and Ideas - FF Pfaffenhofen"/>

    <div>
      <div class="container">
        <span class="large-icon">
          <font-awesome-icon icon="car-crash" />
        </span>

        <div class="header-container">
          <h1>Tests und Experimente</h1>
          <p>Extra Seite für die Umsetzung von verschiedenen Ideen und Vorschlägen zu neuen Features oder neuen Designs von alten Features. <br>Diese Seite ist nicht direkt auf der Seite verlinkt und nur über die /tests URL zugänglich. </p>

          <p v-if="userID">Benutzer ist angemeldet. <br>
          Vorsicht bei der Nutzung der Features, die Daten ändern. Hierbei kann es zu unerwarteten Fehlern oder anderen Bugs kommen.</p>

        </div>

        <div class="header-container">
          <h1>Einsätze der Feuerwehr Pfaffenhofen</h1>
          <p>Hier finden Sie eine komplette Übersicht über Einsätze der Freiwillige Feuerwehr Pfaffenhofen.</p>

          <h1>Open ToDos</h1>
          <p>Image Gallery Features: </p>
          <p>1. Upload Image (x)</p>
          <p>2. Delete Image (x)</p>
          <p>3. Set Cover Image, does weird shit, not persistant.</p>
          <p>Create Entry (x)</p>
          <p>Update Entry (x)</p>
          <p>Delete Entry (x)</p>
        
        </div>

        <br>
        <br>





        <div class="create-box" v-if="userID">
        <button class="btn-default" @click="createShow()">
          <font-awesome-icon icon="plus-circle" />
          Neuer Einsatz</button>
        </div>


        <!--  
        <div class="heatmap">
          <p><span class="count">6</span> Einsätze im letzten Jahr</p>
          <calendar-heatmap :values="[{ date: '2018-9-22', count: 6 }]" :end-date="2018-9-22" :locale="my_locale"/>
        </div> -->



      </div>

      <div class="container">
        <div class="timeline" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">

          <div class="entry" v-for="(data, index) in operations" :key="data.id">
            <span class="created">Vor {{data.readableDate}}</span>

            <span class="icon icon-fire" v-if="data.category.toLowerCase() == 'brand'">
              <span>
                <font-awesome-icon icon="fire"/>
              </span>
            </span>
            <span class="icon icon-fr" v-else-if="data.category.toLowerCase() == 'first responder'">
              <span>
                <font-awesome-icon icon="user"/>
              </span>
            </span>
            <span class="icon icon-thl"
               v-else-if="data.category.toLowerCase() == 'thl' 
               || data.category.toLowerCase() =='technische hilfeleistung'
               || data.category.toLowerCase() =='technische hilfe'">
              <span>
                <font-awesome-icon icon="car-crash"/>
              </span>
            </span>
            <span class="icon" v-else>
              <span>
                <font-awesome-icon icon="map-marker"/>
              </span>
            </span>

            <span class="line first-line" v-if="index == 0"></span>
            <span class="line" v-if="index != 0"></span>
            <div class="title-row">
              <span class="type type-fire" v-if="data.category.toLowerCase() == 'brand'">{{data.category}}</span>
              <span class="type type-fr" v-else-if="data.category.toLowerCase() == 'first responder'">{{data.category}}</span>
              <span class="type type-thl"
                v-else-if="data.category.toLowerCase() == 'thl' 
                || data.category.toLowerCase() =='technische hilfeleistung'
                || data.category.toLowerCase() =='technische hilfe'">
                {{data.category}}</span>
              <span class="type" v-else>{{data.category}}</span>
              <span class="title">{{data.title}}</span>
            </div>
              <div class="details-row">
              <span class="location">
                <font-awesome-icon icon="map-marker" />
                <span class="location-text">{{data.place}}</span>
              </span>
              <span class="time">
                <font-awesome-icon icon="clock" />
                <span class="time-text">{{data.start}}</span>
              </span>
            </div>
            <div class="title-image" v-if="data.image_files && data.image_files.length > 0">
              <img :src="'https://ff-pfaffenhofen.de/' + data.image_files[data.coverImgIdx].file_url" alt="">
            </div>
            <div class="description" v-html="data.description"></div>
            <div class="option-row" v-if="userID">
              <span class="option-text edit-text">Bearbeiten</span>
              <button class="edit" @click="editShow(data.id, index)">
                <font-awesome-icon icon="cog" />
              </button>
              <span class="option-text upload-text">Bilder hochladen</span>
              <button class="upload" @click="appendShow(data.id, index)">
                <font-awesome-icon icon="file-upload" />
              </button>
              <span class="option-text delete-text">Löschen</span>
              <button class="delete" @click="removeShow(data.id, index)">
                <font-awesome-icon icon="trash" />
              </button>
            </div>
            <div class="gallery" v-if="data.image_files && data.image_files.length > 0">
              <p class="description">Mehr Bilder zum Einsatz:</p>
              <div class="image-gallery">
                <div class="image-container" v-for="(image, imgIdx) in data.image_files" :key="image.id">
                 <img  :src="'https://ff-pfaffenhofen.de/' + image.thumb_url" :alt="imgIdx" class="thumbnail">  
                 <div class="overlay">
                   <div class="btn-bar">
                     <button title="Titelbild ändern" v-if="userID" @click="changeCoverImg(index, imgIdx)">
                        <font-awesome-icon icon="images" />
                     </button>
                     <button title="Löschen" v-if="userID" @click="removeImage(image.file_id, index, imgIdx)">
                       <font-awesome-icon icon="trash" />
                     </button>
                     <button title="Vergrößern" @click="openGallery(index, imgIdx)" >
                       <font-awesome-icon icon="expand" />
                     </button>
                   </div>
                 </div>
                </div>
              </div>
               <LightBox :images="data['lightbox_data']" :ref="'lightbox' + index" :show-caption="true" :show-light-box="false"></LightBox>
            </div>
            <div class="social-media"></div>
          </div>

          <div class="entry entry-last">
            <span class="icon icon-last">
              <span>
                <font-awesome-icon icon="spinner" spin v-if="!reachedEnd"/>
                <font-awesome-icon icon="dot-circle" v-else/>
              </span>
            </span>
            <span class="line line-last"></span>
            <div class="title-row">
              <span class="type" v-if="!reachedEnd">Laden...</span>
              <span class="type" v-else>Ende</span>
            </div>
            <div class="description description-last" v-if="reachedEnd">
             Keine weiteren Einträge vorhanden.
            </div>
          </div>

        </div>
      </div>

      <modal name="create-modal" :pivotY=0.2 height="auto" :adaptive="true" :clickToClose="false" width="740px" :scrollable="true">
        <div class="create-modal modal">
          <h1>Neuer Einsatz</h1>
          <p>Legen Sie neue Einträge über das folgende Formular an.</p>
          <form @submit.prevent="createSubmit()">
            <div class="page-1" v-if="createData.page == 1">
              <div class="flex-row">
                <div class="col-6">
                  <label for="title">Titel <span class="required">*</span></label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="heading"/>
                    </span>
                    <input type="text" placeholder="Titel"  v-model="createData.title"/>
                  </div>
                  <p class="input-error" v-if="createData.errorTitle">Feld muss ausgefüllt werden.</p>
                  <label for="title">Kategorie</label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="tags"/>
                    </span>
                    <input type="text" placeholder="Kategorie, z.B. THL oder Brand"  v-model="createData.category"/>
                  </div>
                </div>
                <div class="col-6">
                  <label for="title">Startzeit</label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="clock"/>
                    </span>
                    <input type="text" placeholder="Dienstag, 21.08.2018 - 21:50"  v-model="createData.start"/>
                  </div>
                  <label for="title">Endzeit</label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="clock"/>
                    </span>
                    <input type="text" placeholder="Dienstag, 21.08.2018 - 22:20"  v-model="createData.end"/>
                  </div>
                </div>
              </div>
              <label for="title">Ort</label>
              <div class="input-row">
                <span class="input-icon">
                  <font-awesome-icon icon="map-pin"/>
                </span>
                  <input type="text" placeholder="Ort, Straße, ..."  v-model="createData.place"/>
              </div>
              <label for="title">Inhalt <span class="required">*</span></label>
              <wysiwyg v-model="createData.body" placeholder="Text der Ankündigung" />
              <p class="input-error" v-if="createData.errorBody">Feld muss ausgefüllt werden.</p>
              <div class="footer">
                <button class="btn-primary" type="submit">
                  <font-awesome-icon icon="plus-circle" />
                  Erstellen
                </button>
                <button class="btn-default" @click="createHide()" type="reset">Abbrechen</button>
              </div>
            </div>
            
          </form>
        </div>
      </modal>

      <modal name="delete-modal" :pivotY=0.2 height="auto" :adaptive="true">
        <div class="delete-modal modal">
          <h1>Wirklich Löschen?</h1>
          <p>
            Sind Sie sicher das sie den Einsatz mit dem Titel <b>{{selectedTitle}}</b> wirklich löschen wollen. <br><br>
            Gelöschte Einsätze kommen nicht wiederhergestellt werden.           
          </p>
          <div class="footer">
            <button class="btn-primary" @click="removeSubmit()">
              <font-awesome-icon icon="trash"/>
              Löschen</button>
            <button class="btn-default" @click="removeHide()">Abbrechen</button>
          </div>
        </div>
      </modal>

      <modal name="edit-modal" :pivotY=0.2 height="auto" :adaptive="true" :clickToClose="false" width="740px" :scrollable="true">
        <div class="edit-modal modal">
          <h1>Bearbeiten des Inhaltes</h1>
          <p>Bearbeiten von Einsatz <b>{{ editData.origTitle }}</b>.</p>
          <form @submit.prevent="editSubmit()">
          <div class="page-1" v-if="editData.page == 1">
              <div class="flex-row">
                <div class="col-6">
                  <label for="title">Titel <span class="required">*</span></label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="heading"/>
                    </span>
                    <input type="text" placeholder="Titel"  v-model="editData.title"/>
                  </div>
                  <p class="input-error" v-if="editData.errorTitle">Feld muss ausgefüllt werden.</p>
                  <label for="title">Kategorie</label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="tags"/>
                    </span>
                    <input type="text" placeholder="Kategorie"  v-model="editData.category"/>
                  </div>
                </div>
                <div class="col-6">
                  <label for="title">Startzeit</label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="clock"/>
                    </span>
                    <input type="text" placeholder="Dienstag, 21.08.2018 - 21:50"  v-model="editData.start"/>
                  </div>
                  <label for="title">Endzeit</label>
                  <div class="input-row">
                    <span class="input-icon">
                      <font-awesome-icon icon="clock"/>
                    </span>
                    <input type="text" placeholder="Dienstag, 21.08.2018 - 22:20"  v-model="editData.end"/>
                  </div>
                </div>
              </div>
              <label for="titel">Ort</label>
              <div class="input-row">
                <span class="input-icon">
                  <font-awesome-icon icon="map-pin"/>
                </span>
                  <input type="text" placeholder="Ort, Straße, ..."  v-model="editData.place"/>
              </div>
              <label for="title">Inhalt <span class="required">*</span></label>
              <wysiwyg v-model="editData.body" placeholder="Text der Ankündigung" />
              <p class="input-error" v-if="editData.errorBody">Feld muss ausgefüllt werden.</p>
              <div class="footer">
                <button class="btn-primary" @click="editSubmit()" type="submit">
                  <font-awesome-icon icon="cog"/>
                  Bearbeiten
                </button>
                <button class="btn-default" @click="editHide()" type="reset">Abbrechen</button>
              </div>
            </div>
          </form>
        </div>
      </modal>

      <modal name="append-modal" :pivotY=0.2 height="auto" :adaptive="true" :clickToClose="false">
      <div class="append-modal modal">
        <h1>Dateien hochladen</h1>
        <p>
          Fügen Sie Einträgen Bild-Dateien hinzu. Seite muss je nach verwendetem Browser evlt. manuell neu geladen werden damit Bilder angezeigt werden.
          <br><br>
          Das als erstes hochgeladene Bild wird immer als Cover für den Eintrag verwendet.
        </p>
        <label for="files">Dateien</label>
        <vue-dropzone ref="vueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
        <div class="footer">
          <button class="btn-primary" @click="appendSubmit()">
            <font-awesome-icon icon="file-upload"/>
            Fertig</button>
          <button class="btn-default" @click="appendHide()">Abbrechen</button>
        </div>
      </div>
    </modal>

      
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import LightBox from 'vue-image-lightbox'
import { EventBus } from '../event-bus.js'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { CalendarHeatmap } from 'vue-calendar-heatmap'

export default {
  name: 'operations',
  components: {
    Header, LightBox, LMap, LTileLayer, LMarker, Footer, CalendarHeatmap,
    vueDropzone: vue2Dropzone
  },
  data: () => {
    return {
      userID: "",
      operations: [],
      busy: true,
      reachedEnd: false,
      selectedID: 0,
      selectedIndex: 0,
      selectedTitle: "Not selected",
      createData: {
        page: 1,
        title: "",
        category: "",
        body: "",
        start: "",
        end: "",
        coords: "not set",
        place: "",
        errorTitle: false,
        errorBody: false
      },
      editData: {
        page: 1,
        id: "",
        title: "",
        origTitle: "",
        category: "",
        body: "",
        start: "",
        end: "",
        coords: "",
        place: "",
        errorTitle: false,
        errorBody: false
      },
      dropzoneOptions: {
        url: 'https://ff-pfaffenhofen.de/api/v1/operations/create/file',
        resizeWidth: 1024,
        acceptedFiles: '.jpg,.jpeg,.png',
        maxFilesize: 2,
        params: {
          opID: 1
        }
      }
    }
  },
  mounted() {
    this.userID = this.$session.get("userID")

    this.axios.get('https://ff-pfaffenhofen.de/api/v1/operations')
      .then( (res) => {
        this.operations = res["data"]["operations"]
        this.busy = false

        this.operations.forEach(element => {
          let createdYear = element.created.substring(0, 4)
          element.createdYear = createdYear
          
          let showYear = this.lastCreated != createdYear
          element.createdShow = showYear
          element.coverImgIdx = 0

          element.readableDate = this.readableDate(element.created)
          this.lastCreated = createdYear

        })

      })
    
    EventBus.$on('logout', () => {
      this.userID = ""
    })
    EventBus.$on('login', (userID) => {
      this.userID = userID
    })

  },
  methods: {
    loadMore() {

      this.busy = true
      this.axios.get(
        'https://ff-pfaffenhofen.de/api/v1/operations', {
          params: {
            offset: this.operations.length
          }
        })
      .then( (res) => {
        let data = res.data["operations"]
        data.forEach(item => {
          
          let createdYear = item.created.substring(0, 4)
          item.createdYear = createdYear

          let showYear = this.lastCreated != createdYear
          item.createdShow = showYear

          item.readableDate = this.readableDate(item.created)
          item.coverImgIdx = 0

          this.lastCreated = createdYear

          this.operations.push(item)
        });

        console.log(data)


        if(data.length != 0) {
          this.busy = false
        } else {
          this.reachedEnd = true
        }
      })
      .catch( () => {
        this.reachedEnd = true;
      })

    },
    readableDate(date) {

      if (typeof date !== 'object') {
        date = new Date(date);
      }

      let seconds = Math.floor((new Date() - date) / 1000);
      let intervalType;

      let interval = Math.floor(seconds / 31536000);
      if (interval >= 1) {
        intervalType = 'Jahr';
      } else {
        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
          intervalType = 'Monat';
        } else {
          interval = Math.floor(seconds / 86400);
          if (interval >= 1) {
            intervalType = 'Tag';
          } else {
            interval = Math.floor(seconds / 3600);
            if (interval >= 1) {
              intervalType = "Stunde";
            } else {
              interval = Math.floor(seconds / 60);
              if (interval >= 1) {
                intervalType = "Minute";
              } else {
                interval = seconds;
                intervalType = "Sekunde";
              }
            }
          }
        }
      }

      if (interval > 1 || interval === 0) {
        intervalType += 'en';
      }

      intervalType = intervalType.replace('ee', 'e');

      return interval + ' ' + intervalType;
    },
    openGallery(idx, imgIdx) {
      const lightbox = this.$refs['lightbox' + idx]
      lightbox[0].showImage(imgIdx)
    },
    changeCoverImg(idx, imgIdx) {

      this.operations[idx].coverImgIdx = imgIdx
      //this.operations[idx].title = imgIdx

      //TODO: save in database, create field
    },
     createShow() {
      this.$modal.show('create-modal')
    },
    createHide() {
      this.$modal.hide('create-modal')
      this.createData.title = ""
      this.createData.category = ""
      this.createData.body = ""
      this.createData.place = ""
      this.createData.start = ""
      this.createData.end = ""
    },
    createSubmit() {
      this.createData.errorTitle = false
      this.createData.errorBody = false
      let error = false

      if(!this.createData.title) {
        this.createData.errorTitle = true
        error = true
      }

      if(!this.createData.body || this.createData.body == "<br>") {
        this.createData.errorBody = true
        error = true
      }

      if(error) return;

      let data = {
        title: this.createData.title,
        body: this.createData.body,
        category: this.createData.category,
        userID: this.userID,
        place: this.createData.place,
        coords: this.createData.coords,
        start: this.createData.start,
        end: this.createData.end
      }

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/operations/create', 
        data , {withCredentials: true})
      .then((response) => {
        let resData = response.data
        resData.readableDate = "0 Sekunden"
        this.operations.unshift(resData)
        this.$modal.hide('create-modal')
      })

      // Fix time field
    },
    removeShow(id, index) {
      this.selectedID = id
      this.selectedIndex = index
      this.selectedTitle = this.operations[index].title
      this.$modal.show('delete-modal')
    },
    removeHide() {
      this.$modal.hide('delete-modal')
    },
    removeSubmit() {

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/operations/delete', {
        opID: this.selectedID
      }, {withCredentials: true})
      .then(() => {
        this.$modal.hide('delete-modal')
        this.operations.splice(this.selectedIndex, 1)
      })

    },
    editShow(id, index) {
      this.selectedID = id
      this.selectedIndex = index

      this.editData.id = id
      this.editData.title = this.operations[index].title
      this.editData.origTitle = this.operations[index].title
      this.editData.category = this.operations[index].category
      this.editData.body = this.operations[index].description
      this.editData.start = this.operations[index].start
      this.editData.end = this.operations[index].end
      this.editData.coords = this.operations[index].coords
      this.editData.place = this.operations[index].place

      this.$modal.show('edit-modal')
    },
    editHide() {
        this.$modal.hide('edit-modal')
    },
    editSubmit() {
      this.editData.errorTitle = false
      this.editData.errorBody = false
      let error = false

      if(!this.editData.title) {
        this.editData.errorTitle = true
        error = true
      }

      if(!this.editData.body || this.editData.body == "<br>") {
        this.editData.errorBody = true
        error = true
      }

      if(error) return;

      let data = {
        opID: this.selectedID,
        title: this.editData.title,
        body: this.editData.body,
        category: this.editData.category,
        userID: this.userID,
        place: this.editData.place,
        coords: this.editData.coords,
        start: this.editData.start,
        end: this.editData.end
      }

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/operations/edit', 
        data , {withCredentials: true})
      .then(() => {
        this.$modal.hide('edit-modal')
        this.editData.page = 1
        this.operations[this.selectedIndex].title = this.editData.title
        this.operations[this.selectedIndex].category = this.editData.category
        this.operations[this.selectedIndex].description = this.editData.body
        this.operations[this.selectedIndex].start = this.editData.start
        this.operations[this.selectedIndex].end = this.editData.end
        this.operations[this.selectedIndex].place = this.editData.place
        this.operations[this.selectedIndex].coords = this.editData.coords

      })

    },
    appendShow(id, index) {
      this.selectedID = id
      this.selectedIndex = index
      this.dropzoneOptions.params.opID = id
      this.$modal.show('append-modal')
    },
    appendHide() {
      this.$modal.hide('append-modal')
    },
    appendSubmit() {
      this.$modal.hide('append-modal')

      // XXX make dynamic
      this.userID = this.$session.get("userID")
      this.axios.get('https://ff-pfaffenhofen.de/api/v1/operations')
        .then( (res) => {
          this.operations = res["data"]["operations"]
          console.log(res["data"]["operations"])

          this.operations.forEach(element => {
            let createdYear = element.created.substring(0, 4)
            element.createdYear = createdYear
            
            let showYear = this.lastCreated != createdYear
            element.createdShow = showYear
            element.coverImgIdx = 0

            element.readableDate = this.readableDate(element.created)
            this.lastCreated = createdYear
          })
          this.busy = false
        })
    },
    removeImage(id, idx, attIdx) {
      this.axios.post('https://ff-pfaffenhofen.de/api/v1/operations/delete/file', {
          "opID": id
        }, {withCredentials: true})
      .then(() => {
        let imgFiles = this.operations[idx]["image_files"]
        imgFiles.splice(attIdx, 1)
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "../styles/theme.scss";

.header-container {
  padding-top: 50px;

  h1, p {
    color: rgba(0,0,0,.75);
    text-align: center;
  }
}

.heatmap {
  p {
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-weight: 600;
  }
}

.debug {
  border: 1px solid rgba(0,0,0,.25)
}

.timeline {
  margin-bottom: 50px;

  .entry {
    padding: 20px 20px 70px 80px;
    position: relative;

    @include desktop {
      padding: 20px 20px 80px 220px;
    }
  }

  .line {
    position: absolute;
    height: 100%;
    width: 1px;
    top: 0;
    left: 30px;
    background: rgba(0,0,0,.33);
    z-index: 0;
     @include desktop {
      left: 180px
    }
  }

  .first-line {
    height: calc(100% - 30px);
    top: 30px;
  }

  .line-last {
    height: 50px;
    top: 0px;
  }

  .icon {
    position: absolute;
    height: 28px;
    width: 28px;
    border: 3px solid $dark;
    border-radius: 100%;
    top: 24px;
    left: 14px;
    background: $light-0;
    z-index: 1;
    text-align: center;
    line-height: 28px;
    color: rgba(0,0,0,.8);
    @include desktop {
      left: 164px
    }
  }

  .icon-thl {
    border: 3px solid #DD3719;
  }

  .icon-fr {
    border: 3px solid #239DD4;
  }

  .icon-fire {
    border: 3px solid $primary;
  }

  .created {
    display: none;

    @include desktop {
      display: block;
      position: absolute;
      top: 30px;
      left: 0;
      width: 155px;
      font-size: 14px;
      color: rgba(0,0,0,.75);
      text-align: right;
    }
  }

  .title-row {

    margin-top: -10px;

    @include tablet {
      margin-top: 0px;
    }

    .type {
      background: linear-gradient(55deg, $dark, $dark-0); 
      color: $light-0;
      padding: 3px 12px;
      border-radius: 12px;
      margin-right: 12px;
      font-size: 14px;
      font-weight: 800;
    }

    .type-thl {
      background: $primary;
      background: linear-gradient(316deg, #2A5CAA, #DD3719); 
    }

    .type-fr {
      background: linear-gradient(316deg, rgb(5, 53, 75), #239DD4);
    }

    .type-fire {
      background: linear-gradient(57deg, $primary-0, $dark);
    }
    
    .title {
      text-transform: uppercase;
      font-weight: 600;
      font-size: 16px;
      display: block;
      margin-top: 9px;

      @include tablet {
        display: inline;
        font-size: 22px;
      }
    }
  }

  .details-row {
    margin-top: 10px;
    color: rgba(0,0,0,0.7);

    .location-text, .time-text {
      margin-left: 5px;
      font-weight: 600;
      color: rgba(0,0,0,1);
    }

    .time {
      display: block;
      margin-top: 5px;
      @include tablet {
        display: inline;
        margin-left: 20px;
      }
    }
  }

  .description {
    margin-top: 30px;
    color: rgba(0,0,0,.85);
    line-height: 20px;
    font-size: 14px;

    @include tablet {
      line-height: 28px;
      font-size: 18px;
    }
  }

  .description-last {
    margin-top: 10px;
    color: rgba(0,0,0,1)
  }

  .title-image {

    margin: 20px 0px 10px 0px;

    img {
      height: 128px;
      width: 100%;
      border-radius: 16px;
      object-fit: cover;
      box-shadow: $shadow-medium;

      @include tablet {
        height: 256px;
      }


    }
  }

  .image-gallery {
    margin-top: 15px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 15px;

    @include tablet {
      grid-template-columns: 1fr 1fr 1fr;
    }

    @include desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    .thumbnail {
      border-radius: 12px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      box-shadow: $shadow-light;
    }

    .image-container {
      position: relative;  
    }

    .overlay {
      height: 100%;
      width: 100%;
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 12px;

      display: flex;
      justify-content: center;
      align-items: center;

      transition: 0.5s;

      &:hover {
        background: rgba(0,0,0,.2);

        button {
          display: inline;
        }
      }

      button {
        background: none;
        border: none;
        outline: none;
        color: $light-0;
        font-size: 32px;
        cursor: pointer;
        display: none;

        &:hover {
          color: $primary;
          transition: 0.5s;
        }
      }
      
    }
  }

  .option-row {
    .option-text {
      display: none;

      @include desktop {
        display: block;
        position: absolute;
        top: 90px;
        left: 0;
        width: 145px;
        font-size: 14px;
        color: rgba(0,0,0,.75);
        text-align: right;
      }
    }

    button {
      position: absolute;
      height: 40px;
      width: 40px;
      border: 3px solid $dark;
      border-radius: 100%;
      left: 11px;
      background: $light-0;
      z-index: 1;
      text-align: center;
      line-height: 28px;
      color: $light-0;
      font-size: 16px;
      background:  $dark-0;
      box-shadow: $shadow-medium;
      cursor: pointer;

      @include desktop {
        left: 161px
      }

      transition: all 0.5s;

      &:hover {
        background: $dark;
        transition: all 0.5s;
      }
    }

    .delete {
      background: $primary;
      top: 155px;
      border: 3px solid $primary;

      &:hover {
        background: $light-0;
        border: 3px solid black;
        color: black;
        transition: all 0.5s;
      }
    }

    .edit {
      top: 65px;
    }

    .edit-text {
      top: 75px;
    }

    .upload {
      top: 110px;
    }

    .upload-text {
      top: 120px;
    }

    .delete-text {
      top: 165px;
    }
  }
}

.entry-last {
  .title-row {
    margin-top: 8px;
  }
}


.create-box {
  display: flex;
  justify-content: center;
  margin: 10px 0px 0px 0px;
  padding: 20px 0px 0px 0px;

  .btn-default {
    width: 100%;
    background: $light-0;
    padding: 20px;
    font-size: 18px;
    font-weight: bold;
    border: 2px dashed #b3b3b3;

    transition: 200ms;
    &:hover {
      border: 2px dashed $primary;
      color: $primary;
      transition: 200ms;
    }

    svg {
      color: $primary;
      margin-right: 10px;
    }
  }
}

.modal {
  padding: 10px 30px;

  h1 {
    color: $primary;

    .number {
      font-size: 22px;
      opacity: 0.7;
    }
  }

  p {
    color: lighten($dark, 40);
    font-size: 14px;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;

    .col-6 {
      width: 100%;

      @include tablet {
        width: 49%;

      }
    }
  }

  .footer {
    margin: 60px 0px 20px 0;
    display: flex;
    flex-direction: row-reverse;

    button  {
      font-size: 18px;
      font-weight: bold;
      margin-left: 12px;
    }
    .btn-default {
      color: lighten($dark, 40);

      &:hover {
        color: $dark;
      }
    }
    .btn-primary {
      color: desaturate($primary, 40);

      &:hover {
        color: $primary;
      }
    }
  }

  label {
    color: $dark;
    font-weight: bolder;

    .required {
      color: $primary-1;
    }
  }

  .input-row {
    margin: 4px 0px 12px 0px;
    display: flex;
  }

  .input-icon {
    background: lighten($gray, 48);
    color: lighten($dark, 12);
    
    border: 1px solid #e4e4e4;
    border-right: none;
    padding: 8px 14px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  input {
    flex-grow: 1;
    border: 0px;
    padding: 0px 12px;
    border: 1px solid #e4e4e4;
    font-size: 16px;

    &:focus, &:active {
      box-shadow: 0px 0px 4px $primary;
    }
  }

  .input-error {
    color: $primary;
    margin-top: -6px;
  }

  .map {
    height: 350px;
    width: 100%;
  }
}

</style>



